(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2240],{

/***/ 40335:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ getOptions; }
});

;// CONCATENATED MODULE: ./src/helpers/labels/integrationPaymentTypes.ts
/* harmony default export */ var integrationPaymentTypes = ([
    "mercadoPagoCard",
    "mercadoPagoCardMX",
    "mercadoPagoCardCO",
    "stripeMX",
    "kushkiPE",
    "kushkiCO",
    "kushkiCOPSE",
    "kushkiCL",
    "kushkiCLPlus",
    "kushkiAsyncCL",
    "kushkiWebpay",
    "webpayOneClick",
    "webpayOneClickTest",
    "khipu",
    "webpay",
    "webpayCurry",
    "orion",
    "amipass",
    "sodexo",
    "edenred",
    "mach",
    "chek",
    "fpay",
    "payUCOCard",
    "fpayPE",
    "kushkiEC",
    "proSuenos",
    "epaymentsCR",
    "paypalMX",
    "placeToPayCardEC",
    "bankTransfer",
    "niubizPE",
    "niubizButtonPE",
    "mercadoPagoWalletCO",
    "mercadoPagoPSECO"
]);

// EXTERNAL MODULE: ./src/hooks/useSessionStorageState.ts
var useSessionStorageState = __webpack_require__(11612);
;// CONCATENATED MODULE: ./src/components/Checkout/Confirm/getDefaultOptions.ts
var getDefaultOptions = function() {
    return {
        orderParams: null,
        billing: null,
        addressId: null,
        channel: null,
        tipAmount: null,
        itemsPrice: null,
        amountToPay: null,
        storeId: null,
        menuId: null,
        deliveryType: null,
        dropOffType: null,
        time: null,
        paymentType: null,
        couponCode: null,
        tableName: null,
        cashAmount: null,
        nationalId: null,
        cardId: null,
        otherPaymentType: null,
        skipPhoneValidation: true,
        sessionEmail: null,
        sessionPhone: null,
        chatCommerceType: null
    };
};
/* harmony default export */ var Confirm_getDefaultOptions = (getDefaultOptions);

;// CONCATENATED MODULE: ./src/components/Checkout/Confirm/getOptions.ts
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}



function getOptions(param) {
    var preferences = param.preferences;
    if (preferences.isIncognitoSession) {
        var incognitoSessionPaymentType;
        if (preferences.incognitoSessionPreferences.incognitoSessionPaymentType) incognitoSessionPaymentType = preferences.incognitoSessionPreferences.incognitoSessionPaymentType;
        return {
            options: _objectSpread({}, Confirm_getDefaultOptions(), preferences, {
                paymentType: incognitoSessionPaymentType
            })
        };
    }
    var cart = preferences.cart, deliveryType = preferences.deliveryType, channel = preferences.channel, address = preferences.address, time = preferences.time, paymentType = preferences.paymentType, cashAmount = preferences.cashAmount, nationalId = preferences.nationalId, otherPaymentType = preferences.otherPaymentType, menuId = preferences.menuId, store = preferences.store, cardId = preferences.cardId, couponCode = preferences.couponCode, tableName = preferences.tableName, orderParams = preferences.orderParams, billingParams = preferences.billingParams, sessionEmail = preferences.sessionEmail, sessionPhone = preferences.sessionPhone, chatCommerceType = preferences.chatCommerceType, gift = preferences.gift;
    var calculatedTipAmount = cart.calculatedTipAmount, itemsPrice = cart.itemsPrice, amountToPay = cart.amountToPay;
    if (!preferences.store) {
        if (deliveryType === "delivery") {
            return {
                missingFields: "Por favor indica tu direcci\xf3n de despacho"
            };
        } else {
            return {
                missingFields: "Selecciona un local"
            };
        }
    }
    // if (deliveryType === 'delivery' && address) {
    //   if (!address.addressLine2 && !address.acceptsNoLine2) {
    //     return {
    //       missingFields:
    //         'Debes indicar si tu dirección de entrega es una casa o el número de departamento y guardar'
    //     }
    //   }
    // }
    var payingCashOnDelivery = paymentType === "cash" && deliveryType === "delivery";
    var options = {
        orderParams: orderParams,
        billing: billingParams,
        addressId: deliveryType === "delivery" ? address ? address._id : null : null,
        channel: channel,
        tipAmount: integrationPaymentTypes.includes(paymentType) ? calculatedTipAmount : null,
        itemsPrice: itemsPrice,
        amountToPay: amountToPay,
        storeId: store._id,
        menuId: menuId,
        deliveryType: deliveryType,
        dropOffType: preferences.dropOffType,
        time: time,
        paymentType: paymentType,
        couponCode: couponCode,
        tableName: tableName,
        cashAmount: payingCashOnDelivery ? cashAmount : null,
        nationalId: nationalId,
        cardId: cardId,
        otherPaymentType: paymentType === "other" && deliveryType === "delivery" ? otherPaymentType : null,
        skipPhoneValidation: deliveryType === "serve",
        sessionEmail: sessionEmail,
        sessionPhone: sessionPhone,
        chatCommerceType: chatCommerceType,
        gift: gift,
        source: (0,useSessionStorageState/* getSavedValue */.z)("orderSource", "web") || "web"
    };
    return {
        options: options
    };
};


/***/ }),

/***/ 7737:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Quantity; }
/* harmony export */ });
/* harmony import */ var _codebuild_output_src914630519_src_codestar_connections_us_east_1_amazonaws_com_git_http_765846071129_us_east_1_2b8358da_528f_4cea_9fc4_c84ee5141e4b_getjusto_justo_services_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _codebuild_output_src914630519_src_codestar_connections_us_east_1_amazonaws_com_git_http_765846071129_us_east_1_2b8358da_528f_4cea_9fc4_c84ee5141e4b_getjusto_justo_services_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_codebuild_output_src914630519_src_codestar_connections_us_east_1_amazonaws_com_git_http_765846071129_us_east_1_2b8358da_528f_4cea_9fc4_c84ee5141e4b_getjusto_justo_services_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _data_fragments_checkout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41989);
/* harmony import */ var _hooks_useMessage__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5528);
/* harmony import */ var apollo_hooks__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3172);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(50456);
/* harmony import */ var lodash_range__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(96026);
/* harmony import */ var lodash_range__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lodash_range__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(42124);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_8__);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}

function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n          mutation setBagsRequiredPreferences($websiteId: ID, $bagsRequired: Float) {\n            setUserPreferences(websiteId: $websiteId, bagsRequired: $bagsRequired) {\n              ...checkoutPreferences\n            }\n          }\n          ",
        "\n        "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}








function Quantity(param) {
    var preferences = param.preferences;
    var showMessage = (0,_hooks_useMessage__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();
    var mutate = (0,apollo_hooks__WEBPACK_IMPORTED_MODULE_5__/* .useMutate */ .Tu)();
    var bagsRequired = preferences.bagsRequired, cart = preferences.cart, websiteId = preferences.websiteId;
    var value1 = bagsRequired || cart.calculatedBagsRequired || 1;
    var maxBagsAllowed = cart.maxBagsAllowed;
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (!value1 || !maxBagsAllowed) return;
        if (value1 > maxBagsAllowed) updateBagsRequiredPreferences(maxBagsAllowed);
    }, [
        value1,
        maxBagsAllowed
    ]);
    var updateBagsRequiredPreferences = function() {
        var _ref = _asyncToGenerator(_codebuild_output_src914630519_src_codestar_connections_us_east_1_amazonaws_com_git_http_765846071129_us_east_1_2b8358da_528f_4cea_9fc4_c84ee5141e4b_getjusto_justo_services_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(value) {
            return _codebuild_output_src914630519_src_codestar_connections_us_east_1_amazonaws_com_git_http_765846071129_us_east_1_2b8358da_528f_4cea_9fc4_c84ee5141e4b_getjusto_justo_services_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return mutate({
                            mutation: (0,graphql_tag__WEBPACK_IMPORTED_MODULE_7__["default"])(_templateObject(), _data_fragments_checkout__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z),
                            variables: {
                                websiteId: websiteId,
                                bagsRequired: Number(value)
                            }
                        });
                    case 3:
                        _ctx.next = 8;
                        break;
                    case 5:
                        _ctx.prev = 5;
                        _ctx.t0 = _ctx["catch"](0);
                        showMessage(_ctx.t0);
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    5
                ]
            ]);
        }));
        return function updateBagsRequiredPreferences(value) {
            return _ref.apply(this, arguments);
        };
    }();
    var onChange = function(event) {
        updateBagsRequiredPreferences(event.target.value);
    };
    var renderOptions = function() {
        return lodash_range__WEBPACK_IMPORTED_MODULE_6___default()(1, maxBagsAllowed + 1).map(function(amount) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("option", {
                value: String(amount),
                children: amount
            }, amount);
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_8___default().container),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("select", {
            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_8___default().select),
            onChange: onChange,
            value: String(value1),
            children: renderOptions()
        })
    });
};


/***/ }),

/***/ 27284:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ UIKit_Alert; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/hooks/useState.ts
var useState = __webpack_require__(48249);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/react-icons/md/index.esm.js
var index_esm = __webpack_require__(5434);
;// CONCATENATED MODULE: ./src/components/UIKit/Alert/CloseIcon/index.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}




function CloseIcon(props) {
    return props.show ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MdClose */.FU5, _objectSpread({}, props)) : null;
}
CloseIcon.propTypes = {
    show: (prop_types_default()).bool
};
/* harmony default export */ var Alert_CloseIcon = (CloseIcon);

// EXTERNAL MODULE: ./node_modules/react-icons/fa/index.esm.js
var fa_index_esm = __webpack_require__(89583);
;// CONCATENATED MODULE: ./src/components/UIKit/Alert/Icon/index.tsx





function Icon(props) {
    var show = props.show, type = props.type, className = props.className;
    if (!show) return null;
    switch(type){
        case "success":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MdCheckCircle */.ZSR, {
                size: "22",
                className: className
            });
        case "warning":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(fa_index_esm/* FaExclamationTriangle */.gJy, {
                size: "19",
                className: className
            });
        case "danger":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MdError */.vVM, {
                size: "22",
                className: className
            });
        default:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MdInfo */.I5p, {
                size: "22",
                className: className
            });
    }
}
Icon.propTypes = {
    type: (prop_types_default()).string,
    show: (prop_types_default()).bool,
    className: (prop_types_default()).string
};
/* harmony default export */ var Alert_Icon = (Icon);

// EXTERNAL MODULE: ./src/components/UIKit/Alert/styles.module.css
var styles_module = __webpack_require__(24631);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/components/UIKit/Alert/index.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function Alert_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}








function Alert(props) {
    var type = props.type, title = props.title, description = props.description, showIcon = props.showIcon, showClose = props.showClose, animated = props.animated, children = props.children;
    var ref = _slicedToArray((0,useState/* default */.Z)(true), 2), show = ref[0], setShow = ref[1];
    if (!show) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((styles_module_default()).container, (styles_module_default())["bg-".concat(type)], Alert_defineProperty({}, (styles_module_default()).animation, animated)),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert_Icon, {
                show: showIcon,
                type: type,
                className: classnames_default()((styles_module_default())["color-".concat(type)], (styles_module_default()).icon)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (styles_module_default()).subContainer,
                children: [
                    title ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (styles_module_default()).title,
                        children: title
                    }) : null,
                    description ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (styles_module_default()).description,
                        children: description
                    }) : null,
                    children ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: children
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert_CloseIcon, {
                show: showClose,
                // @ts-expect-error ts-migrate(2322) FIXME: Type '{ show: any; className: string; onClick: () ... Remove this comment to see the full error message
                className: classnames_default()((styles_module_default())["color-".concat(type)], (styles_module_default()).closeIcon),
                onClick: function() {
                    return setShow(false);
                }
            })
        ]
    });
}
Alert.propTypes = {
    type: prop_types_default().oneOf([
        "info",
        "danger",
        "warning",
        "success"
    ]),
    title: (prop_types_default()).string,
    description: (prop_types_default()).string,
    showIcon: (prop_types_default()).bool,
    showClose: (prop_types_default()).bool,
    animated: (prop_types_default()).bool,
    children: (prop_types_default()).node
};
Alert.defaultProps = {
    type: "info",
    showIcon: true,
    showClose: false,
    animated: false
};
/* harmony default export */ var UIKit_Alert = (Alert);


/***/ }),

/***/ 41989:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ checkout; }
});

// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 1 modules
var lib = __webpack_require__(50456);
;// CONCATENATED MODULE: ./src/data/fragments/checkout/billingFragment.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  fragment checkoutBillingPreferences on Preference {\n    _id\n    billing\n    website {\n      _id\n      billingParamsSchema\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ var billingFragment = ((0,lib["default"])(_templateObject()));

// EXTERNAL MODULE: ./src/data/fragments/checkout/deliveryFragment.ts
var deliveryFragment = __webpack_require__(88511);
;// CONCATENATED MODULE: ./src/data/fragments/checkout/orderParamsFragment.ts
function orderParamsFragment_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function orderParamsFragment_templateObject() {
    var data = orderParamsFragment_taggedTemplateLiteral([
        "\n  fragment checkoutOrderParamsPreferences on Preference {\n    _id\n    orderParams\n    website {\n      _id\n      menuConfiguration {\n        orderParamsSchema\n      }\n    }\n  }\n"
    ]);
    orderParamsFragment_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ var orderParamsFragment = ((0,lib["default"])(orderParamsFragment_templateObject()));

;// CONCATENATED MODULE: ./src/data/fragments/checkout/paymentFragment.ts
function paymentFragment_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function paymentFragment_templateObject() {
    var data = paymentFragment_taggedTemplateLiteral([
        "\n  fragment checkoutPaymentPreferences on Preference {\n    _id\n    paymentType\n    cashAmount\n    nationalId\n    otherPaymentType\n    cardId\n    card {\n      _id\n      brandId\n      last4\n      brandName\n      paymentType\n      cardType\n    }\n    store {\n      _id\n      availablePaymentTypes\n      hideTip\n    }\n    website {\n      _id\n      otherPaymentTypes\n    }\n    user {\n      _id\n      cards {\n        _id\n        brandId\n        brandName\n        last4\n        paymentType\n        cardType\n      }\n    }\n  }\n"
    ]);
    paymentFragment_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ var paymentFragment = ((0,lib["default"])(paymentFragment_templateObject()));

;// CONCATENATED MODULE: ./src/data/fragments/checkout/profileFragment.ts
function profileFragment_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function profileFragment_templateObject() {
    var data = profileFragment_taggedTemplateLiteral([
        "\n  fragment checkoutProfilePreferences on Preference {\n    _id\n    sessionEmail\n    user {\n      _id\n      name\n      email\n      phone\n      profile {\n        firstName\n        lastName\n      }\n    }\n  }\n"
    ]);
    profileFragment_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ var profileFragment = ((0,lib["default"])(profileFragment_templateObject()));

// EXTERNAL MODULE: ./src/data/fragments/cartFragment/cartItemFragment.main.ts
var cartItemFragment_main = __webpack_require__(90932);
;// CONCATENATED MODULE: ./src/data/fragments/checkout/resumeFragment.ts
function resumeFragment_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function resumeFragment_templateObject() {
    var data = resumeFragment_taggedTemplateLiteral([
        "\n  fragment checkoutResumePreferences on Preference {\n    _id\n    deliveryType\n    channel\n    address {\n      _id\n    }\n    time\n    paymentType\n    tipAmount\n    tipPercentage\n    cashAmount\n    nationalId\n    otherPaymentType\n    menuId\n    bagsRequired\n    store {\n      _id\n      hasDelayInAcceptingOrders\n      activeAlertMessage\n      activeAlertClosedMessage\n      hideTip\n    }\n    website {\n      _id\n      noTipByDefault\n    }\n    cardId\n    couponCode\n    cart {\n      specialRequirementsIds\n      deliveryType\n      deliveryFee\n      hasDynamicDeliveryFee\n      menuId\n      itemsPrice\n      acceptsTip\n      hasFixedAmountTips\n      tipOptions\n      tipPercentagesOptions\n      calculatedTipAmount\n      originalItemsPrice: itemsPrice(includeDiscount: false)\n      totalPrice\n      amountToPay\n      bagAmount\n      maxBagsAllowed\n      pointsDetails {\n        amount\n        name\n      }\n      couponStatus {\n        couponId\n        code\n        errorMessage\n        name\n        discount\n      }\n      loyaltyTransactionStatus {\n        transactionId\n        loyaltyName\n        discount\n      }\n      items {\n        ...resumeCartItem\n      }\n      benefits\n    }\n    reducedDemand {\n      enabled\n      message\n    }\n  }\n  ",
        "\n"
    ]);
    resumeFragment_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


/* harmony default export */ var resumeFragment = ((0,lib["default"])(resumeFragment_templateObject(), cartItemFragment_main/* default */.Z));

;// CONCATENATED MODULE: ./src/data/fragments/checkout/index.ts
function checkout_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function checkout_templateObject() {
    var data = checkout_taggedTemplateLiteral([
        "\n  fragment checkoutPreferences on Preference {\n    _id\n    websiteId\n    storeId\n    deliveryType\n    menuId\n    sessionEmail\n    sessionEmailHasAccount\n    sessionEmailHasName\n    sessionPhone\n    chatCommerceType\n    loyaltyProgram\n    ...checkoutResumePreferences\n    ...checkoutDeliveryPreferences\n    ...checkoutPaymentPreferences\n    ...checkoutProfilePreferences\n    ...checkoutOrderParamsPreferences\n    ...checkoutBillingPreferences\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    checkout_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







/* harmony default export */ var checkout = ((0,lib["default"])(checkout_templateObject(), resumeFragment, deliveryFragment/* default */.Z, paymentFragment, profileFragment, orderParamsFragment, billingFragment));


/***/ }),

/***/ 57846:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getQueryParam; }
/* harmony export */ });
function getQueryParam(param) {
    var query = param.query, key = param.key;
    var value = query[key];
    if (!value) return;
    return value;
};


/***/ }),

/***/ 64105:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ useURLState; }
});

// EXTERNAL MODULE: ./node_modules/lodash/isNull.js
var isNull = __webpack_require__(45220);
var isNull_default = /*#__PURE__*/__webpack_require__.n(isNull);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/hooks/useURLState/getQueryParam.ts
var getQueryParam = __webpack_require__(57846);
// EXTERNAL MODULE: ./src/helpers/misc/getQueryObject.ts
var getQueryObject = __webpack_require__(62280);
;// CONCATENATED MODULE: ./src/hooks/useURLState/setQueryParam.ts


function setQueryParam(param) {
    var key = param.key, value = param.value, router = param.router, replaceHistory = param.replaceHistory;
    var searchParams = (0,getQueryObject/* default */.Z)(router);
    if (isNull_default()(value)) {
        delete searchParams[key];
    } else {
        searchParams[key] = value;
    }
    if (replaceHistory) {
        var ref;
        router.push({
            pathname: window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : ref.pathname,
            query: searchParams
        });
    }
};

;// CONCATENATED MODULE: ./src/hooks/useURLState/index.ts




function useURLState(key) {
    var initialValue = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, replaceHistory = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    var router = (0,next_router.useRouter)();
    var queryParam = (0,getQueryParam/* default */.Z)({
        query: router.query,
        key: key
    }) || initialValue;
    var onChange = function(newValue) {
        if (isNull_default()(newValue)) {
            setQueryParam({
                key: key,
                value: null,
                replaceHistory: replaceHistory,
                router: router
            });
        } else {
            setQueryParam({
                key: key,
                value: newValue,
                replaceHistory: replaceHistory,
                router: router
            });
        }
    };
    return [
        queryParam,
        onChange
    ];
};


/***/ }),

/***/ 76709:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useWebsiteInfo; }
/* harmony export */ });
/* harmony import */ var _hooks_useWebsiteId__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(16825);
/* harmony import */ var _page_components_Layout_useInitialData__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62832);
/* harmony import */ var apollo_hooks__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3172);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50456);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      query getWebsiteInfo($websiteId: ID) {\n        website(websiteId: $websiteId) {\n          _id\n          name\n          description\n          countryCode\n          timezone\n          country {\n            canSendDevolutionDataEmail\n            locale\n          }\n          foodCategoriesCodes\n          baseURL\n        }\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




// returns only the most general website information
function useWebsiteInfo() {
    var websiteId = (0,_hooks_useWebsiteId__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
    var initialData = (0,_page_components_Layout_useInitialData__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)();
    var website = (0,apollo_hooks__WEBPACK_IMPORTED_MODULE_2__/* .useApolloQuery */ .Zu)({
        query: (0,graphql_tag__WEBPACK_IMPORTED_MODULE_3__["default"])(_templateObject()),
        variables: {
            websiteId: websiteId
        },
        fetchPolicy: "cache-first",
        omit: !websiteId || !!initialData
    }).website;
    if (initialData) {
        website = initialData.website;
    }
    if (!website) return {};
    return {
        websiteId: website._id,
        websiteName: website.name,
        websiteDescription: website.description,
        websiteCountryCode: website.countryCode,
        websiteCanSendDevolutionDataEmail: website.country.canSendDevolutionDataEmail,
        websiteCategories: website.foodCategoriesCodes,
        websiteTimezone: website.timezone,
        websiteLocale: website.country.locale,
        websiteBaseURL: website.baseURL
    };
};


/***/ }),

/***/ 53928:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ roundMoney; }
});

// EXTERNAL MODULE: ./node_modules/lodash/round.js
var round = __webpack_require__(59854);
var round_default = /*#__PURE__*/__webpack_require__.n(round);
;// CONCATENATED MODULE: ./src/i18n/roundMoney/localeDecimals.ts
var localeDecimals = {
    es_CL: 0,
    es_MX: 2,
    es_PE: 2,
    es_CO: 0,
    es_EC: 2,
    en_US: 2,
    es_CR: 2
};
/* harmony default export */ var roundMoney_localeDecimals = (localeDecimals);

;// CONCATENATED MODULE: ./src/i18n/roundMoney/index.ts


function roundMoney(number) {
    var locale = __webpack_require__.g.currentLocale || "es_CL";
    var decimals = roundMoney_localeDecimals[locale] || 0;
    return round_default()(number, decimals);
};


/***/ }),

/***/ 87336:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Content; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/Button/index.tsx
var Button = __webpack_require__(40076);
// EXTERNAL MODULE: ./src/components/UIKit/Alert/index.tsx + 2 modules
var Alert = __webpack_require__(27284);
// EXTERNAL MODULE: ./src/hooks/useSessionStorageState.ts
var useSessionStorageState = __webpack_require__(11612);
// EXTERNAL MODULE: ./src/hooks/useURLState/index.ts + 1 modules
var useURLState = __webpack_require__(64105);
// EXTERNAL MODULE: ./src/hooks/useUserId.ts
var useUserId = __webpack_require__(77883);
// EXTERNAL MODULE: ./src/page-components/Order/CartLoadingContext.tsx
var CartLoadingContext = __webpack_require__(10177);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 50 modules
var esm = __webpack_require__(32533);
// EXTERNAL MODULE: ./src/page-components/Order/Options/UpdateBasicOptions/index.tsx + 1 modules
var UpdateBasicOptions = __webpack_require__(82096);
// EXTERNAL MODULE: ./src/page-components/Checkout/CheckoutV2/Profile/LoginAtCheckout/index.tsx + 6 modules
var LoginAtCheckout = __webpack_require__(53584);
// EXTERNAL MODULE: ./src/page-components/Order/Cart/Content/TableOrders/Login/styles.module.css
var styles_module = __webpack_require__(9362);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/page-components/Order/Cart/Content/TableOrders/Login/index.tsx






function Login(props) {
    var preferences = props.preferences, setShowLogin = props.setShowLogin;
    var user = preferences.user, sessionEmailHasAccount = preferences.sessionEmailHasAccount;
    if (user) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (styles_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert/* default */.Z, {
                    description: "Para continuar, ingresa tu email. Ah\xed recibir\xe1s la confirmaci\xf3n del pedido y tu boleta."
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (styles_module_default()).login,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginAtCheckout/* default */.Z, {
                    preferences: preferences
                })
            }),
            sessionEmailHasAccount ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (styles_module_default()).button,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    onClick: function() {
                        return setShowLogin(false);
                    },
                    primary: true,
                    children: "Continuar como invitado"
                })
            }) : null
        ]
    });
};

// EXTERNAL MODULE: ./src/page-components/Order/Cart/Content/Item/index.tsx + 2 modules
var Item = __webpack_require__(98316);
// EXTERNAL MODULE: ./src/components/Checkout/Confirm/createOrder.ts + 1 modules
var createOrder = __webpack_require__(99344);
// EXTERNAL MODULE: ./src/components/Checkout/Confirm/getOptions.ts + 2 modules
var getOptions = __webpack_require__(40335);
// EXTERNAL MODULE: ./src/i18n/formatNumber/Component.tsx
var Component = __webpack_require__(18085);
// EXTERNAL MODULE: ./src/components/Money/Bags/Quantity/index.tsx
var Quantity = __webpack_require__(7737);
// EXTERNAL MODULE: ./src/components/Money/Bags/styles.module.css
var Bags_styles_module = __webpack_require__(15292);
var Bags_styles_module_default = /*#__PURE__*/__webpack_require__.n(Bags_styles_module);
;// CONCATENATED MODULE: ./src/components/Money/Bags/index.tsx





function Tip(props) {
    var _preferences = props.preferences, deliveryType = _preferences.deliveryType, bagAmount = _preferences.cart.bagAmount;
    var renderLine = function(label, value, style) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: style || (Bags_styles_module_default()).line,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Bags_styles_module_default()).label,
                    children: label
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: value
                })
            ]
        });
    };
    if (!bagAmount) return null;
    if (deliveryType !== "go") return renderLine("Bolsas", /*#__PURE__*/ (0,jsx_runtime.jsx)(Component/* default */.Z, {
        value: bagAmount
    }));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Bags_styles_module_default()).container,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (Bags_styles_module_default()).head,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Bags_styles_module_default()).quantity,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Quantity/* default */.Z, {
                        preferences: props.preferences
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Bags_styles_module_default()).name,
                    children: "Bolsas"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Component/* default */.Z, {
                        value: bagAmount
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/helpers/misc/deliveryFeeText.ts
var deliveryFeeText = __webpack_require__(31000);
// EXTERNAL MODULE: ./src/helpers/posthog/index.ts
var posthog = __webpack_require__(53023);
// EXTERNAL MODULE: ./src/helpers/track/useTrackEcommerceEvent.ts + 6 modules
var useTrackEcommerceEvent = __webpack_require__(55870);
// EXTERNAL MODULE: ./src/hooks/useIdempotencyKey.ts
var useIdempotencyKey = __webpack_require__(60839);
// EXTERNAL MODULE: ./src/hooks/useIsSpecialLayout.ts
var useIsSpecialLayout = __webpack_require__(5455);
// EXTERNAL MODULE: ./src/hooks/useTimeField/index.ts + 9 modules
var useTimeField = __webpack_require__(96986);
// EXTERNAL MODULE: ./src/hooks/useTimeField/types.ts
var types = __webpack_require__(12994);
// EXTERNAL MODULE: ./src/hooks/useWebsiteInfo.ts
var useWebsiteInfo = __webpack_require__(76709);
// EXTERNAL MODULE: ./src/i18n/formatNumber/index.ts + 1 modules
var formatNumber = __webpack_require__(78263);
// EXTERNAL MODULE: ./src/page-components/Checkout/Checkout/Delivery/Duration/Update/TimeField/index.tsx + 1 modules
var TimeField = __webpack_require__(14473);
// EXTERNAL MODULE: ./node_modules/apollo-hooks/dist/apollo-hooks.es.js
var apollo_hooks_es = __webpack_require__(3172);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 1 modules
var lib = __webpack_require__(50456);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/page-components/Order/Cart/Content/Resume/styles.module.css
var Resume_styles_module = __webpack_require__(8744);
var Resume_styles_module_default = /*#__PURE__*/__webpack_require__.n(Resume_styles_module);
;// CONCATENATED MODULE: ./src/page-components/Order/Cart/Content/Resume/index.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      query pendingTermsCart($userId: String, $email: String, $websiteId: String) {\n        pendingTermInfos(userId: $userId, email: $email, websiteId: $websiteId)\n        me {\n          _id\n          name\n        }\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




























var SignTerms = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6178).then(__webpack_require__.bind(__webpack_require__, 66178));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(66178)
            ];
        }
    },
    ssr: false
});
var DynamicDelivery = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6461).then(__webpack_require__.bind(__webpack_require__, 86461));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(86461)
            ];
        }
    }
});
var SendingToKitchen = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6301).then(__webpack_require__.bind(__webpack_require__, 66301));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(66301)
            ];
        }
    }
});
function getOffset(htmlElement) {
    var rect = htmlElement.getBoundingClientRect();
    return {
        left: rect.left + window.scrollX,
        top: rect.top + window.scrollY
    };
}
function Resume(props) {
    var cart = props.cart, preferences = props.preferences, website = props.website, whatsappChatCommerceNumber = props.whatsappChatCommerceNumber;
    var ref = (0,useTimeField/* default */.Z)(), timeOptions = ref.deliveryTimeTimeOptions, deliveryTimeType = ref.deliveryTimeType;
    var itemsPrice = cart.itemsPrice, realPrice = cart.realPrice, totalPrice = cart.totalPrice, bagAmount = cart.bagAmount, items = cart.items, deliveryType = cart.deliveryType, storeId = cart.storeId;
    var mutate = (0,apollo_hooks_es/* useMutate */.Tu)();
    var t = (0,esm/* useTranslation */.$G)().t;
    var i18nWebsite = "website:order.cart.content.resume";
    var i18nGeneric = "generic:fields";
    var ref1 = (0,useIdempotencyKey/* default */.Z)(), idempotencyKey = ref1.idempotencyKey, regenerateIdempotencyKey = ref1.regenerateIdempotencyKey;
    var ref2 = (0,react.useState)(), errorMessage = ref2[0], setErrorMessage = ref2[1];
    var ref3 = (0,react.useState)(), setVerifyPhone = ref3[1];
    var ref4 = (0,react.useState)(), setCreateCard = ref4[1];
    var ref5 = (0,react.useState)(false), sendingToKitchen = ref5[0], setSendingToKitchen = ref5[1];
    var options = (0,getOptions/* default */.Z)(props).options;
    var router = (0,next_router.useRouter)();
    var isSpecialLayout = (0,useIsSpecialLayout/* default */.Z)();
    var ref6 = _slicedToArray((0,useSessionStorageState/* default */.Z)("onTable"), 1), onTable = ref6[0];
    var ref7 = _slicedToArray((0,useSessionStorageState/* default */.Z)("orderGroupId"), 1), orderGroupId = ref7[0];
    var ref8 = (0,react.useState)(false), redirecting = ref8[0], setRedirecting = ref8[1];
    var ref9 = (0,useWebsiteInfo/* default */.Z)(), websiteId = ref9.websiteId, websiteName = ref9.websiteName;
    var userId = (0,useUserId/* default */.Z)();
    var checkoutPath = "/checkout";
    (0,react.useEffect)(function() {
        router.prefetch(checkoutPath);
    }, [
        router,
        checkoutPath
    ]);
    var ref10 = (0,apollo_hooks_es/* useApolloQuery */.Zu)({
        query: (0,lib["default"])(_templateObject()),
        variables: {
            userId: userId,
            websiteId: websiteId,
            email: preferences.sessionEmail
        },
        partial: true
    }), pendingTermInfos = ref10.pendingTermInfos, me = ref10.me;
    var trackEcommerceEvent = (0,useTrackEcommerceEvent/* default */.Z)();
    var hasNoName = !me && !preferences.sessionEmailHasName || me && me.name === "Sin nombre";
    var requiredTermInfos = (pendingTermInfos || []).filter(function(term) {
        return !term.optional;
    });
    var requiredTermVersions = requiredTermInfos.map(function(term) {
        return term.latestVersion;
    });
    var ref11 = (0,react.useState)([]), termSignatures = ref11[0], setTermSignatures = ref11[1];
    var signedTermVersions = termSignatures.map(function(term) {
        return term.version;
    });
    var missingSignatures = requiredTermVersions.some(function(version) {
        return !signedTermVersions.includes(version);
    });
    var goToReview = function() {
        setRedirecting(true);
        trackEcommerceEvent(useTrackEcommerceEvent/* ECOMMERCE_EVENTS.INITCHECKOUT */.X.INITCHECKOUT, {
            cart: cart
        });
        (0,posthog.sendPosthogData)(posthog.EVENTS.clicked.cartContinueToCheckout);
        router.push(checkoutPath);
    };
    var sendToKitchen = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee() {
            var finalOptions, order;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        finalOptions = _objectSpread({}, options, {
                            idempotencyKey: idempotencyKey,
                            termSignatures: missingSignatures ? {} : termSignatures,
                            paymentType: "inStore",
                            orderGroupId: orderGroupId,
                            isTableOrderV2: true
                        });
                        _ctx.next = 3;
                        return (0,createOrder/* default */.Z)({
                            mutate: mutate,
                            history: router,
                            options: finalOptions,
                            setErrorMessage: setErrorMessage,
                            setVerifyPhone: setVerifyPhone,
                            setCreateCard: setCreateCard,
                            regenerateIdempotencyKey: regenerateIdempotencyKey
                        });
                    case 3:
                        order = _ctx.sent;
                        if (order) {
                            router.push("/checkout-on-table/prepare");
                        }
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function sendToKitchen() {
            return _ref.apply(this, arguments);
        };
    }();
    var showSendToKitchen = function() {
        return setSendingToKitchen(true);
    };
    var goToWhatsapp = function() {
        setRedirecting(true);
        trackEcommerceEvent(useTrackEcommerceEvent/* ECOMMERCE_EVENTS.INITCHECKOUT */.X.INITCHECKOUT, {
            cart: cart
        });
        (0,posthog.sendPosthogData)(posthog.EVENTS.clicked.cartContinueToCheckout, {
            chatCommerceType: "whatsapp"
        });
        if (!whatsappChatCommerceNumber) {
            var justoBotPhoneNumber = "18453032928" // TODO: CRUD and fetch from backend
            ;
            router.push("/whatsapp-redirect?phone=".concat(justoBotPhoneNumber, "&text=Completar"));
            return;
        }
        router.push("/whatsapp-redirect?phone=".concat(whatsappChatCommerceNumber.replace("+", ""), "&text=Completar"));
    };
    var hasAnyOutOfStock = function() {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var item = _step.value;
                if (item.isOutOfStock) return true;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return false;
    };
    var amountToReachMinimum = function() {
        if (!website) return;
        if (!website.minimumOrderPrice) return;
        if (!itemsPrice) return;
        var amount = website.minimumOrderPrice - itemsPrice;
        if (amount > 0) return amount;
        return 0;
    };
    var renderDiscount = function() {
        if (itemsPrice === realPrice) return;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (Resume_styles_module_default()).discount,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Resume_styles_module_default()).label,
                    children: t("".concat(i18nWebsite, ".labelDiscount"))
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        "- ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Component/* default */.Z, {
                            value: realPrice - itemsPrice
                        }),
                        " "
                    ]
                })
            ]
        });
    };
    var renderSubTotal = function() {
        if (onTable) return null;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (Resume_styles_module_default()).itemsPrice,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Resume_styles_module_default()).label,
                    children: t("".concat(i18nWebsite, ".labelSubtotal"))
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: (0,formatNumber/* default */.Z)(realPrice, "money")
                })
            ]
        });
    };
    var renderDeliveryFee = function() {
        if (deliveryType !== "delivery") return null;
        if (!storeId) return null;
        var deliveryFee = cart.deliveryFee;
        var address = preferences.address;
        var dynamicFee = props.preferences && props.preferences.store && props.preferences.store.currentExtraDeliveryCost > 0;
        var deliveryContent = (0,deliveryFeeText/* default */.Z)({
            address: address,
            deliveryFee: deliveryFee
        });
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (Resume_styles_module_default()).itemsPrice,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Resume_styles_module_default()).label,
                    children: t("".concat(i18nGeneric, ".dispatch"))
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: dynamicFee ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicDelivery, {
                        value: deliveryContent
                    }) : deliveryContent
                })
            ]
        });
    };
    var renderButton = function() {
        var disabled = hasAnyOutOfStock();
        if (disabled) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Resume_styles_module_default()).button,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    primary: true,
                    disabled: true,
                    children: t("".concat(i18nWebsite, ".labelProductsOutStock"))
                })
            });
        }
        // if there's no available time options for scheduling
        var hasNoOptions = timeOptions && timeOptions.length === 0;
        if ((deliveryTimeType === null || deliveryTimeType === void 0 ? void 0 : deliveryTimeType.value) === types/* DeliveryTimeTypes.SCHEDULE_ORDER */.H.SCHEDULE_ORDER && hasNoOptions) {
            var scrollToDeliveryTimeTypeSelector = function() {
                var deliveryTimeSelector = document.querySelector("#".concat(TimeField/* DELIVERY_TIME_TYPE_SELECTOR_ID */.U));
                if (deliveryTimeSelector) {
                    window.scroll({
                        top: getOffset(deliveryTimeSelector).top - 20,
                        left: 0,
                        behavior: "smooth"
                    });
                }
            };
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Resume_styles_module_default()).button,
                onClick: scrollToDeliveryTimeTypeSelector,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    primary: true,
                    disabled: true,
                    children: t("".concat(i18nWebsite, ".labelNoSchedulingOptions"))
                })
            });
        }
        var amountToReach = amountToReachMinimum();
        if (amountToReach) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Resume_styles_module_default()).button,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        primary: true,
                        disabled: true,
                        children: t("".concat(i18nWebsite, ".labelNotReachedMin"))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "description",
                        style: {
                            marginTop: 5
                        },
                        children: t("".concat(i18nWebsite, ".labelAddMoreProducts"), {
                            money: (0,formatNumber/* default */.Z)(amountToReach, "money")
                        })
                    })
                ]
            });
        }
        if (onTable) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Resume_styles_module_default()).button,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SignTerms, {
                        websiteId: websiteId,
                        websiteName: websiteName,
                        termInfos: pendingTermInfos,
                        termSignatures: termSignatures,
                        setTermSignatures: setTermSignatures
                    }),
                    hasNoName ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        children: [
                            "No tenemos tu nombre, por favor ve a ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/settings",
                                children: "Mi cuenta"
                            }),
                            " para actualizar tu informaci\xf3n"
                        ]
                    }) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        fullWidth: true,
                        primary: true,
                        onClick: showSendToKitchen,
                        disabled: missingSignatures || hasNoName,
                        children: t("".concat(i18nWebsite, ".labelSendToKitchen"))
                    })
                ]
            });
        }
        if (isSpecialLayout === "chat") {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()((Resume_styles_module_default()).button, (Resume_styles_module_default()).whatsappButton),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    primary: true,
                    onClick: goToWhatsapp,
                    loading: redirecting,
                    children: t("".concat(i18nWebsite, ".labelCompleteOrderInWhatsapp"))
                })
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (Resume_styles_module_default()).button,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                primary: true,
                onClick: goToReview,
                loading: redirecting,
                children: t("".concat(i18nWebsite, ".labelContinueWithMyOrder"))
            })
        });
    };
    if (sendingToKitchen) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(SendingToKitchen, {
            order: cart,
            sendToKitchen: sendToKitchen,
            cancelSending: function() {
                return setSendingToKitchen(false);
            }
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Resume_styles_module_default()).container,
        children: [
            errorMessage ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Resume_styles_module_default()).error,
                children: errorMessage
            }) : null,
            renderSubTotal(),
            renderDeliveryFee(),
            renderDiscount(),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tip, {
                preferences: preferences
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: onTable ? (Resume_styles_module_default()).totalOnTable : (Resume_styles_module_default()).total,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Resume_styles_module_default()).label,
                        children: t("".concat(i18nWebsite, ".labelTotal"))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Component/* default */.Z, {
                                value: totalPrice + bagAmount
                            }),
                            " "
                        ]
                    })
                ]
            }),
            renderButton()
        ]
    });
};

// EXTERNAL MODULE: ./src/hooks/useEffect.ts
var useEffect = __webpack_require__(10338);
// EXTERNAL MODULE: ./src/i18n/roundMoney/index.ts + 1 modules
var roundMoney = __webpack_require__(53928);
// EXTERNAL MODULE: ./src/page-components/Order/Cart/Content/TableOrders/ActionButtons/styles.module.css
var ActionButtons_styles_module = __webpack_require__(25277);
var ActionButtons_styles_module_default = /*#__PURE__*/__webpack_require__.n(ActionButtons_styles_module);
;// CONCATENATED MODULE: ./src/page-components/Order/Cart/Content/TableOrders/ActionButtons/index.tsx






function ActionButtons(props) {
    var checkPlease = function checkPlease() {
        router.push("/checkout-on-table/checkout");
    };
    var continueOrdering = function continueOrdering() {
        setOpenResume(false);
        if (router.asPath !== "/pedir") router.push("/pedir");
    };
    var setOpenResume = props.setOpenResume;
    var router = (0,next_router.useRouter)();
    var t = (0,esm/* useTranslation */.$G)("website", {
        keyPrefix: "order.cart"
    }).t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (ActionButtons_styles_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                fullWidth: true,
                primary: true,
                onClick: checkPlease,
                children: t("payAndCloseTable")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (ActionButtons_styles_module_default()).button,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    onClick: continueOrdering,
                    fullWidth: true,
                    children: t("continueOrderingToTable")
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/react-icons/fa/index.esm.js
var index_esm = __webpack_require__(89583);
// EXTERNAL MODULE: ./src/helpers/dayjs/index.ts
var dayjs = __webpack_require__(70457);
;// CONCATENATED MODULE: ./src/helpers/websites/tableOrders.ts
var isPaymentComplete = function(order) {
    if (!order) return false;
    if (order.paidStatus === "done") return true;
    if (order.isTableOrderV2) {
        if (order.deliveryType === "serve" && order.payInTable) return true;
        if (order.deliveryType === "serve" && order.isTablePaidOnline) return true;
    } else {
        if (order.paidStatus === "toCharge" && order.orderStatus === "done") return true;
    }
    return false;
};
var isOrderDone = function(order) {
    return order.orderStatus === "done";
};
var isOrderCancelled = function(order) {
    return order.orderStatus === "cancelled";
};
var isOrderComplete = function(order) {
    return isOrderDone(order) || isOrderCancelled(order);
};
var requestedPos = function(table) {
    return table.request && table.request.action === "pos" && table.tableTotal > 0;
};

// EXTERNAL MODULE: ./src/hooks/useState.ts
var useState = __webpack_require__(48249);
// EXTERNAL MODULE: ./node_modules/react-icons/md/index.esm.js
var md_index_esm = __webpack_require__(5434);
// EXTERNAL MODULE: ./src/page-components/Order/Cart/Content/TableOrders/Orders/Status/styles.module.css
var Status_styles_module = __webpack_require__(95391);
var Status_styles_module_default = /*#__PURE__*/__webpack_require__.n(Status_styles_module);
;// CONCATENATED MODULE: ./src/page-components/Order/Cart/Content/TableOrders/Orders/Status/index.tsx





var orderStatuses = {
    pending: {
        label: "Por pagar",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(md_index_esm/* MdTimelapse */.sVn, {
            className: (Status_styles_module_default()).orderPreview,
            size: 13,
            color: "#CC493C"
        })
    },
    done: {
        label: "Pagado",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(md_index_esm/* MdCheckCircle */.ZSR, {
            size: 13,
            color: "#00CB8D"
        })
    },
    cancelled: {
        label: "Cancelado",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(md_index_esm/* MdTimerOff */.zdb, {
            size: 13,
            color: "#CC493C"
        })
    },
    _: {
        label: "Por pagar",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(md_index_esm/* MdTimelapse */.sVn, {
            className: (Status_styles_module_default()).orderPreview,
            size: 13,
            color: "#CC493C"
        })
    }
};
function Status(props) {
    var order = props.order;
    var orderStatus = isPaymentComplete(order) ? orderStatuses.done : orderStatuses.pending;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Status_styles_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: orderStatus.label
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: orderStatus.icon
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/page-components/Order/Cart/Content/TableOrders/Orders/styles.module.css
var Orders_styles_module = __webpack_require__(69197);
var Orders_styles_module_default = /*#__PURE__*/__webpack_require__.n(Orders_styles_module);
;// CONCATENATED MODULE: ./src/page-components/Order/Cart/Content/TableOrders/Orders/index.tsx
function Orders_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function Orders_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function Orders_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function Orders_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function Orders_slicedToArray(arr, i) {
    return Orders_arrayWithHoles(arr) || Orders_iterableToArrayLimit(arr, i) || Orders_unsupportedIterableToArray(arr, i) || Orders_nonIterableRest();
}
function Orders_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return Orders_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Orders_arrayLikeToArray(o, minLen);
}










function Orders(props) {
    var _user = props.user, user = _user === void 0 ? {} : _user, _orders = props.orders, orders = _orders === void 0 ? [] : _orders, _count = props.count, count = _count === void 0 ? 0 : _count, _total = props.total, total = _total === void 0 ? 0 : _total;
    var ref = Orders_slicedToArray((0,useState/* useState */.e)(false), 2), isActive = ref[0], setIsActive = ref[1];
    var t = (0,esm/* useTranslation */.$G)("website", {
        keyPrefix: "order.cart.content.resume"
    }).t;
    var unpaidOrdersTotal = orders.filter(function(order) {
        return !isPaymentComplete(order);
    }).reduce(function(previousValue, currentValue) {
        return previousValue + currentValue.amountToPay;
    }, 0);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Orders_styles_module_default()).container,
        onClick: function() {
            return setIsActive(!isActive);
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Orders_styles_module_default()).order,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Orders_styles_module_default()).left,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                children: user.profile.firstName
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h5", {
                                className: (Orders_styles_module_default()).h5,
                                children: [
                                    "(",
                                    count,
                                    ")"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Orders_styles_module_default()).right,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Orders_styles_module_default()).chevron,
                            children: isActive ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    t("labelShowless"),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaChevronUp */.s$2, {
                                        className: (Orders_styles_module_default()).icon
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    t("labelShowMore"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaChevronDown */.RiI, {
                                        className: (Orders_styles_module_default()).icon
                                    })
                                ]
                            })
                        })
                    })
                ]
            }),
            isActive ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Orders_styles_module_default()).containerItems,
                children: orders.map(function(order) {
                    return order.items.map(function(item) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (Orders_styles_module_default()).containerItem,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (Orders_styles_module_default()).itemAmount,
                                    children: item.amount
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (Orders_styles_module_default()).itemName,
                                    children: [
                                        item.product.name,
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (Orders_styles_module_default()).date,
                                            children: [
                                                (0,dayjs/* default */.Z)(order.createdAt).format("HH:mm"),
                                                "hrs."
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (Orders_styles_module_default()).containerItemsPrice,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                            className: (Orders_styles_module_default()).itemUnitPrice,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Component/* default */.Z, {
                                                value: item.unitPrice * item.amount
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Status, {
                                            order: order
                                        })
                                    ]
                                })
                            ]
                        }, item._id);
                    });
                })
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Orders_styles_module_default()).orderGroup,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                        className: (Orders_styles_module_default()).totalOrderPrice,
                        children: unpaidOrdersTotal > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Component/* default */.Z, {
                            value: unpaidOrdersTotal,
                            render: function(number) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: "Por pagar: ".concat(number)
                                });
                            }
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Status, {
                            order: orders[0]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                        className: (Orders_styles_module_default()).totalOrderPrice,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                            children: [
                                "Total: ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Component/* default */.Z, {
                                    value: total
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/page-components/Order/Cart/Content/TableOrders/styles.module.css
var TableOrders_styles_module = __webpack_require__(78883);
var TableOrders_styles_module_default = /*#__PURE__*/__webpack_require__.n(TableOrders_styles_module);
;// CONCATENATED MODULE: ./src/page-components/Order/Cart/Content/TableOrders/index.tsx
function TableOrders_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function TableOrders_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            TableOrders_defineProperty(target, key, source[key]);
        });
    }
    return target;
}









function TableOrders(props) {
    var tableTotal = props.tableTotal, ordersGroupedByUser = props.ordersGroupedByUser, preferences = props.preferences, setOpenResume = props.setOpenResume;
    var refreshQuery = (0,apollo_hooks_es/* useRefetchQueries */.S1)();
    var tip = (0,roundMoney/* default */.Z)(tableTotal * 0.1);
    var totalOrder = (0,roundMoney/* default */.Z)(tableTotal + tip);
    (0,useEffect/* useEffect */.d)(function() {
        refreshQuery("getUserOrderGroup");
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (TableOrders_styles_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (TableOrders_styles_module_default()).orderContainer,
                children: ordersGroupedByUser.map(function(item, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Orders, TableOrders_objectSpread({}, item), index);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (TableOrders_styles_module_default()).pendingOrder,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h4", {
                        children: [
                            "Pago pendiente de Mesa ",
                            preferences.tableName
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Component/* default */.Z, {
                            value: tableTotal
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (TableOrders_styles_module_default()).suggestedTip,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "Propina sugerida (10%) "
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Component/* default */.Z, {
                            value: tip
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (TableOrders_styles_module_default()).pendingOrder,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                        children: "Total a pagar con propina "
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Component/* default */.Z, {
                            value: totalOrder
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionButtons, {
                preferences: preferences,
                setOpenResume: setOpenResume
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/page-components/Order/Cart/Content/useUserOrderGroup.ts
function useUserOrderGroup_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function useUserOrderGroup_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function useUserOrderGroup_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function useUserOrderGroup_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function useUserOrderGroup_slicedToArray(arr, i) {
    return useUserOrderGroup_arrayWithHoles(arr) || useUserOrderGroup_iterableToArrayLimit(arr, i) || useUserOrderGroup_unsupportedIterableToArray(arr, i) || useUserOrderGroup_nonIterableRest();
}
function useUserOrderGroup_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function useUserOrderGroup_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return useUserOrderGroup_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return useUserOrderGroup_arrayLikeToArray(o, minLen);
}
function useUserOrderGroup_templateObject() {
    var data = useUserOrderGroup_taggedTemplateLiteral([
        "\n      query getUserOrderGroup($websiteId: ID, $storeId: ID, $tableName: String) {\n        userOrderGroup(websiteId: $websiteId, storeId: $storeId, tableName: $tableName) {\n          _id\n          tableTotal\n          ordersGroupedByUser {\n            total\n            count\n            user {\n              profile {\n                firstName\n              }\n            }\n            orders {\n              _id\n              code\n              items {\n                _id\n                amount\n                unitPrice\n                product {\n                  _id\n                  name\n                  images {\n                    _id\n                    resizedURL\n                  }\n                }\n              }\n              bagAmount\n              storeId\n              deliveryType\n              deliveryFee\n              menuId\n              itemsPrice\n              totalPrice\n              amountToPay\n              statusLabel\n              orderStatus\n              paymentStatus\n              paidStatus\n              createdAt\n              isTableOrderV2\n              payInTable\n              isTablePaidOnline\n            }\n          }\n        }\n      }\n    "
    ]);
    useUserOrderGroup_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



function useUserOrderGroup(param) {
    var website = param.website, storeId = param.storeId, preferences = param.preferences;
    var ref = useUserOrderGroup_slicedToArray((0,useSessionStorageState/* default */.Z)("orderGroupId", null), 2), orderGroupId = ref[0], setOrderGroupId = ref[1];
    var userOrderGroup = (0,apollo_hooks_es/* useApolloQuery */.Zu)({
        omit: !website || !storeId || !preferences.tableName,
        query: (0,lib["default"])(useUserOrderGroup_templateObject()),
        variables: {
            websiteId: website._id,
            storeId: storeId,
            tableName: preferences.tableName
        }
    }).userOrderGroup;
    if (!orderGroupId && userOrderGroup && userOrderGroup._id) {
        setOrderGroupId(userOrderGroup._id);
    }
    return userOrderGroup;
};

;// CONCATENATED MODULE: ./src/page-components/Order/Cart/Content/useWhatsAppCommerceNumber.ts
function useWhatsAppCommerceNumber_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function useWhatsAppCommerceNumber_templateObject() {
    var data = useWhatsAppCommerceNumber_taggedTemplateLiteral([
        "\n      query getWhatsAppCommerceNumber($websiteId: ID) {\n        website(websiteId: $websiteId) {\n          _id\n          whatsappChatCommerceNumber\n        }\n      }\n    "
    ]);
    useWhatsAppCommerceNumber_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



function useWhatsAppCommerceNumber(websiteId, preferences) {
    var isSpecialLayout = (0,useIsSpecialLayout/* default */.Z)();
    var website = (0,apollo_hooks_es/* useApolloQuery */.Zu)({
        query: (0,lib["default"])(useWhatsAppCommerceNumber_templateObject()),
        variables: {
            websiteId: websiteId
        },
        omit: isSpecialLayout !== "chat"
    }).website;
    return website ? website.whatsappChatCommerceNumber : null;
};

// EXTERNAL MODULE: ./src/page-components/Order/Cart/Content/styles.module.css
var Content_styles_module = __webpack_require__(10658);
var Content_styles_module_default = /*#__PURE__*/__webpack_require__.n(Content_styles_module);
;// CONCATENATED MODULE: ./src/page-components/Order/Cart/Content/index.tsx
function Content_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function Content_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function Content_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function Content_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                Content_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                Content_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function Content_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function Content_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function Content_slicedToArray(arr, i) {
    return Content_arrayWithHoles(arr) || Content_iterableToArrayLimit(arr, i) || Content_unsupportedIterableToArray(arr, i) || Content_nonIterableRest();
}
function Content_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return Content_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Content_arrayLikeToArray(o, minLen);
}




















function Content(props) {
    var preferences = props.preferences, website = props.website, layout = props.layout, refetch = props.refetch, setOpenResume = props.setOpenResume, _defaultScreen = props.defaultScreen, defaultScreen = _defaultScreen === void 0 ? "resume" : _defaultScreen;
    var cart = preferences.cart;
    var storeId = preferences.storeId;
    var userId = (0,useUserId/* default */.Z)();
    var ref = (0,react.useState)(layout === "v2" && !storeId ? false : true), showCart = ref[0], setShowCart = ref[1];
    var t = (0,esm/* useTranslation */.$G)().t;
    var i18nWebsite = "website:order.cart";
    var i18nGeneric = "generic:fields";
    var whatsappChatCommerceNumber = useWhatsAppCommerceNumber(website._id, preferences);
    var ref1 = (0,react.useState)(defaultScreen), showScreen = ref1[0], setShowScreen = ref1[1];
    var ref2 = Content_slicedToArray((0,useSessionStorageState/* default */.Z)("onTable"), 1), onTable = ref2[0];
    var router = (0,next_router.useRouter)();
    var userOrderGroup = useUserOrderGroup({
        website: website,
        storeId: storeId,
        preferences: preferences
    });
    var ref3 = Content_slicedToArray((0,useSessionStorageState/* default */.Z)("onTable.showLogin", true), 2), showLogin = ref3[0], setShowLogin = ref3[1];
    var ref4 = Content_slicedToArray((0,useURLState/* default */.Z)("seeTableOrder"), 1), seeTableOrder = ref4[0];
    var isOpenQueryParam = seeTableOrder === "true";
    var loading = (0,CartLoadingContext/* useCartLoading */.k6)().loading;
    (0,react.useEffect)(function() {
        if (isOpenQueryParam) setShowScreen("tableOrders");
    }, [
        isOpenQueryParam,
        seeTableOrder
    ]);
    function checkPlease() {
        return _checkPlease.apply(this, arguments);
    }
    function _checkPlease() {
        _checkPlease = Content_asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        router.push("/checkout-on-table/checkout");
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return _checkPlease.apply(this, arguments);
    }
    if (!cart) return null;
    if (showLogin && onTable && !userId) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Login, {
            preferences: preferences,
            setShowLogin: setShowLogin
        });
    }
    if (!showCart) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (Content_styles_module_default()).optionsContent,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(UpdateBasicOptions/* default */.Z, {
                    preferences: preferences
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Content_styles_module_default()).buttonContinue,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        disabled: !storeId,
                        onClick: function() {
                            return setShowCart(true);
                        },
                        primary: true,
                        children: t("".concat(i18nGeneric, ".continue"))
                    })
                })
            ]
        });
    }
    var closeTable = onTable && userOrderGroup ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Content_styles_module_default()).buttonCloseTable,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
            fullWidth: true,
            onClick: checkPlease,
            children: t("".concat(i18nWebsite, ".payAndCloseTable"))
        })
    }) : null;
    var tabs = onTable ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Content_styles_module_default()).tabsButtons,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()((Content_styles_module_default()).option, showScreen === "resume" ? (Content_styles_module_default()).active : null),
                onClick: function() {
                    return setShowScreen("resume");
                },
                children: t("".concat(i18nWebsite, ".currentOrder"))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()((Content_styles_module_default()).option, showScreen === "tableOrders" ? (Content_styles_module_default()).active : null),
                onClick: function() {
                    return setShowScreen("tableOrders");
                },
                children: t("".concat(i18nWebsite, ".totalAmount"))
            })
        ]
    }) : null;
    if (showScreen === "tableOrders") {
        if (!userOrderGroup) return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                tabs,
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert/* default */.Z, {
                        description: t("".concat(i18nWebsite, ".noOrdersSentToKitchen"))
                    })
                })
            ]
        });
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                tabs,
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableOrders, {
                    preferences: preferences,
                    ordersGroupedByUser: userOrderGroup.ordersGroupedByUser,
                    tableTotal: userOrderGroup.tableTotal,
                    setOpenResume: setOpenResume
                })
            ]
        });
    }
    if (cart.items.length === 0) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                tabs,
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Content_styles_module_default()).empty,
                    children: t("".concat(i18nWebsite, ".emptyCart"))
                }),
                closeTable
            ]
        });
    }
    if (showCart) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (Content_styles_module_default()).container,
            children: [
                tabs,
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Content_styles_module_default()).items,
                    children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex animate-pulse px-4",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "h-20 w-full bg-gray-200 rounded"
                        })
                    }) : cart.items.map(function(item) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Item/* default */.Z, {
                            item: item,
                            preferences: preferences,
                            readOnly: false,
                            amountClassname: ""
                        }, item._id);
                    })
                }),
                cart.items.length > 5 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Content_styles_module_default()).shadow
                }) : null,
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Resume, {
                    website: website,
                    cart: cart,
                    preferences: preferences,
                    whatsappChatCommerceNumber: whatsappChatCommerceNumber,
                    refetch: refetch
                }),
                closeTable
            ]
        });
    }
};


/***/ }),

/***/ 42124:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"xx2Lj14c6QC-rE8GEJp0G","select":"_16FGiRyaY5QWm5L-0_5EkY secondaryBackgroundColor textColor backgroundBorderColor"};

/***/ }),

/***/ 15292:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_2EeC5UeCLNph8Wve0qZ1jY cartItem backgroundBorderColor","head":"_29-A11DS_oz_e316wACNTr","name":"_39dYfHkWUnTkEi1C-DhWW-","line":"_3iDLTzqWwinZiXi4FLvvU2","label":"dfaFe8BY_DNimADNpPAIB","quantity":"_2UsW3iYqMKd-i8W853d4lX"};

/***/ }),

/***/ 24631:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_2ByACJnWE-2F6Zxy8v3wCO","animation":"_1hC3TcskuLxZilWM7TxFkY animated shake","icon":"_2jeti7BJNQKJmG_TlABkuL","subContainer":"_37piA8zoWZAyIs8f3eGb86","closeIcon":"_3Gnf8I44y382W-M9c-stKW","title":"_2fclFEpqkHYyP82YoSmwsQ","description":"FMyvbiGSkOQN61Uygl8xJ","bg-info":"_142fwN-zUHHd6q5oODeF0O","bg-success":"_2ojOXk65L_4-uDMr5BwHOF","bg-warning":"_24EY9V02LVWp2FyL5mH7de","bg-danger":"_2LcNXIJErL7R2gBcY2lR6G","color-info":"_1Q97nQ_iXPpxaIQQ5a9Czh","color-success":"_3J0IrScugkGawF3UWyALqM","color-warning":"_1lG9CQ89FV6Dh1sVPqpJWV","color-danger":"ZJRjMK2Rh8iFp_KqYzlbW"};

/***/ }),

/***/ 8744:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_2afy5O68bYwlybgRzAiiv1","row":"STyBpJnmQl5_aXes1SmKB","itemsPrice":"_1Rj3LvzCGDm64X9KAyz9Gr STyBpJnmQl5_aXes1SmKB","discount":"_1NmshcgeglDgJ0dkot1ARM STyBpJnmQl5_aXes1SmKB","total":"_3yim9IxqOhX8YA919uUUDr STyBpJnmQl5_aXes1SmKB","totalOnTable":"_1vdE0k7FgyHqFLUiLhPpda STyBpJnmQl5_aXes1SmKB","button":"_1d78VmrKdLRfpj62_yqwIW","error":"_3nXaN_0Qp35ohfW6fieXRD animated shake"};

/***/ }),

/***/ 25277:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_3ibi15R6VkaPevLtpTPSVi"};

/***/ }),

/***/ 9362:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_35DX03AaOcJuIMaO5C_qgT","login":"_2phrT1uRAYrUU09fq0hu5r","button":"_1g0FXY4Ox3I98IaeEgTaWq"};

/***/ }),

/***/ 95391:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_24dw6g4ALiwWonqvW2VK-5"};

/***/ }),

/***/ 69197:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_3WPEnWHfTH8NCZfgpuMFbP","right":"_39Xt87ii9L9DvQod9cB_2","left":"_1mLQUIjgogZuikWP7vbul_","date":"_304_3DG-pGTwiNl8bRxPaN","chevron":"_2qGVwqw5RKmYRbv8cN7f2w","icon":"_1I0DprELWAj_LH-2BaDtzr","order":"_3pEYWrN4KpEsmsp6XfOaLJ","containerItems":"_2fHpAd255Pjmqqh5dg5M4t","containerItem":"_1dRDl-eqEYcr3V9XduBjXD","containerItemsPrice":"_9M-tE32NDZNbGM_hJoOgE","itemAmount":"_1pM8PKP4SJ9igKrlOnqVn3","itemName":"_18DUUrxgEJr2Kt0j1ONniu","itemUnitPrice":"_1xuNo0ZKXmXbSO_3leng7T","totalOrderPrice":"_2POBHNrv7ntA0HjObl3s7F","orderGroup":"BAPzIaE7nDeev6_tpVshI"};

/***/ }),

/***/ 78883:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_1zDizZf24NDWsJC40dOISj","pendingOrder":"_3m7IBskDntCS5FJB3CJeKY","suggestedTip":"QTJJXU-fglYQnzyEP66o1","orderContainer":"_3j9ZwOPwP1O9i7-XvRIFYq"};

/***/ }),

/***/ 10658:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"DGJHGnSi0Ay-FkL9f2An8 cartContainer","empty":"_2w5_689wrIb7IPXZt8Aya2 descriptionTextColor","closed":"_2gHYYUjYLixq3x4BD8l-uJ","storeName":"OgxB2HF0_w3UACU6yoQFa","items":"_1VEcuxgBRZndK-8WxGPOYP","optionsContent":"_1z_LpH4CG8awgIKZQnFFJ_","buttonContinue":"_26i_tqg9Cl_oQvssIDBH8n","tabsButtons":"_2QoIaBV6gwfwogc0QbSFN3","option":"zjrcGTDW7KMG-3ONrNlho","active":"_3fnsBOIQc2WK6Pw8epsvGE","buttonCloseTable":"_2C7eRYjxOFVeOD8BVSZzq9"};

/***/ }),

/***/ 5275:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
__webpack_unused_export__ = exports.dh = exports.BX = void 0;
const tslib_1 = __webpack_require__(70655);
const fireEvent_1 = (0, tslib_1.__importDefault)(__webpack_require__(93415));
exports.BX = fireEvent_1.default;
const useOnEvent_1 = (0, tslib_1.__importDefault)(__webpack_require__(80967));
exports.dh = useOnEvent_1.default;
const waitAndFire_1 = (0, tslib_1.__importDefault)(__webpack_require__(63921));
__webpack_unused_export__ = waitAndFire_1.default;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 2489:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports["default"] = (time) => new Promise(resolve => setTimeout(resolve, time));
//# sourceMappingURL=sleep.js.map

/***/ }),

/***/ 63921:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(70655);
const fireEvent_1 = (0, tslib_1.__importDefault)(__webpack_require__(93415));
const sleep_1 = (0, tslib_1.__importDefault)(__webpack_require__(2489));
async function waitAndFire(name, data) {
    const results = await (0, fireEvent_1.default)(name, data);
    if (results.length === 0) {
        await (0, sleep_1.default)(100);
        return await waitAndFire(name, data);
    }
    return results;
}
exports["default"] = waitAndFire;
//# sourceMappingURL=waitAndFire.js.map

/***/ })

}]);